export default "__VITE_ASSET__1a9b74d4__"